import type { Webcast } from './types';

const items = import.meta.glob<Webcast>('./webcast/*.json', { eager: true, import: 'default' });
const bodies = import.meta.glob<string>('./webcast/*.html', { query: '?raw', import: 'default' });

/** All webcasts, most recently recorded first. */
export const webcasts: Webcast[] = Object.values(items).sort(
  (a, b) => b.recorded.localeCompare(a.recorded) || a.slug.localeCompare(b.slug),
);

export const getWebcast = (slug: string) => webcasts.find((w) => w.slug === slug);

export async function loadWebcastBody(slug: string): Promise<string> {
  return (await bodies[`./webcast/${slug}.html`]?.()) ?? '';
}
